var map = {
	"./add-2.svg": 856552,
	"./add-3.svg": 368921,
	"./add.svg": 199585,
	"./arrow-down-solid.svg": 828166,
	"./arrow-down.svg": 75432,
	"./arrow-left.svg": 714727,
	"./arrow-right.svg": 733698,
	"./arrow-up.svg": 669339,
	"./bluetooth.svg": 475534,
	"./book.svg": 563007,
	"./camera.svg": 612669,
	"./catalog.svg": 833101,
	"./check-attendance.svg": 191840,
	"./check-mark.svg": 975670,
	"./circle-right.svg": 724173,
	"./close-2.svg": 164345,
	"./close.svg": 932484,
	"./comment.svg": 143615,
	"./copy.svg": 289911,
	"./cross.svg": 63784,
	"./delete-2.svg": 770896,
	"./delete.svg": 422681,
	"./download.svg": 130192,
	"./edit-2.svg": 167705,
	"./edit-3.svg": 655336,
	"./edit-4.svg": 957735,
	"./edit.svg": 437412,
	"./export.svg": 82402,
	"./filter.svg": 915342,
	"./head-phone.svg": 306133,
	"./help.svg": 535249,
	"./history.svg": 317144,
	"./man.svg": 968452,
	"./message.svg": 83557,
	"./more.svg": 259723,
	"./notice.svg": 257628,
	"./photo.svg": 148004,
	"./quit.svg": 438381,
	"./search.svg": 273564,
	"./share.svg": 975785,
	"./signal.svg": 555028,
	"./speaker-louder.svg": 421281,
	"./speaker.svg": 575011,
	"./switch.svg": 516140,
	"./text.svg": 141125,
	"./tips.svg": 419030,
	"./triangle.svg": 636244,
	"./upload-2.svg": 905134,
	"./upload.svg": 278795,
	"./women.svg": 159210,
	"./write.svg": 703357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 520527;